import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';

export interface EmployeeOption {
  id: string;
  employeeNo: string;
  name: string;
  designation: string | null;
}

export function useEmployeeOptions(enabled: boolean) {
  return useQuery({
    queryKey: ['employees', ''],
    queryFn: () => get<EmployeeOption[]>('/hr/employees?limit=300'),
    enabled,
  });
}

export function useLeaveEmployeeOptions(anyone: boolean): { data: EmployeeOption[] | undefined; ownOnly: boolean } {
  const roster = useEmployeeOptions(anyone);
  const own = useQuery({
    queryKey: ['employees', 'me'],
    queryFn: () => get<EmployeeOption>('/hr/employees/me'),
    enabled: !anyone,
    retry: false,
  });
  if (anyone) return { data: roster.data, ownOnly: false };
  return { data: own.data ? [own.data] : undefined, ownOnly: true };
}

export const HR_TAB_PATH = {
  roster: '/people?tab=roster',
  attendance: '/people?tab=attendance',
  leave: '/people?tab=leave',
  payroll: '/people?tab=payroll',
} as const;
